import { useMemo, useContext } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Slider,
  TextField,
  Typography,
  Alert,
  useTheme,
  Box,
  DialogActions,
  Stack,
} from "@mui/material";

import { AppContext } from "../../contextProviders/AppContext";
//Fork used for unmount issue:
//https://github.com/Kiarash-Z/react-modern-calendar-datepicker/issues/204#issuecomment-757520714
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";

import { add, addHours, format, isValid, set } from "date-fns";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import {
  StaticDatePicker,
  StaticDateRangePicker,
} from "@mui/x-date-pickers-pro";
import { translation } from "../Dictionary";

import CloseIcon from "@mui/icons-material/Close";

export default function DateRangeMobileDialog({
  throttle,
  openDateRangeMobile,
  setOpenDateRangeMobile,
  fixedTimeFrames,
  handleDateChange,
  SLIDER_STEP,
  startSliderValue,
  endSliderValue,
  setStartTime,
  setEndTime,
  dayStart,
  endTime,
  startEndSameDay,
  startTime,
  setSelectedTimeFrame,
  selectedTimeFrame,
  FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA,
  getMinimumDate,
  startTimeLabel,
  returnTimeLabel,
}) {
  const {
    language,
    dateRange,
    FEATURE_FIXED_RESERVATION_TIMEFRAME,
    FEATURE_FIXED_RESERVATION_DURATION,
    endDateString,
    startDateString,
    hasError,
    endTimeOk,
    selectedCompany,
    VUOKRAAPAKU_SPECIAL_COMPANY,
    locale,
    selectedDateRange,
    FEATURE_NO_TIME_SELECT,
    disableMultiday,
  } = useContext(AppContext);
  const theme = useTheme();

  // TODO: CHECK IF THIS IS NEEDED
  /*   function TimeErrorText({ endTimeOk }) {
    if (endTimeOk.hasError) {
      return (
        <FormHelperText error style={{ fontSize: 14 }}>
          {endTimeOk.message}
        </FormHelperText>
      );
    }
    return (
      <FormHelperText error style={{ fontSize: 14 }}>
        {translation.get(language, "Check times label")}
      </FormHelperText>
    );
  } */
  // console.log("dates", selectedDateRange);
  function handleSelectedTimeFrame(time, indexValue) {
    if (!startTime) return console.log("fail");
    setSelectedTimeFrame(fixedTimeFrames[indexValue]);
    // Define endtime
    return setEndTime(addHours(startTime, time));
  }

  function FixedTimeFrameSelect({ value, selectedTimeFrame, indexValue }) {
    return (
      <Grid
        item
        container
        style={{
          justifyContent: "center",
          alignItems: "center",
          borderStyle: "solid",
          width: 45,
          height: 45,
          padding: 5,
          margin: 5,
          borderWidth: selectedTimeFrame === value ? 4 : 2,
          borderColor:
            selectedTimeFrame === value
              ? theme.palette.primary.main
              : "lightgrey",
          borderRadius: "50%",
          cursor: "pointer",
        }}
        onClick={() => handleSelectedTimeFrame(value, indexValue)}
      >
        <Typography variant="body1">{value}h</Typography>
      </Grid>
    );
  }

  function handleAdvance() {
    // handleSearch(selectedDateRange[0], selectedDateRange[1]);
    setOpenDateRangeMobile(false);
  }

  const titleBgColor = () => {
    if (endTimeOk.hasError) {
      return theme.palette.warning.light;
    }
    if (selectedCompany && !selectedDateRange[0]) {
      return theme.palette.primary.dateRangeBgFrom;
    }
    if (selectedCompany && selectedDateRange[0] && !selectedDateRange[1]) {
      return theme.palette.primary.dateRangeBgTo;
    }

    if (selectedCompany && selectedDateRange[0] && selectedDateRange[1]) {
      return theme.palette.primary.dateRangeBgComplete;
    }

    return theme.palette.info.main;
  };

  const title = useMemo(() => {
    if (!selectedCompany) return translation.get(language, "Error: No company");
    if (selectedCompany && !selectedDateRange[0])
      return translation.get(language, "Select pickup date");
    if (
      selectedCompany &&
      selectedDateRange[0] &&
      !selectedDateRange[1] &&
      !endTimeOk.hasError
    )
      return translation.get(language, "Select return date");

    if (endTimeOk.hasError === true) {
      return endTimeOk.message;
    }

    if (selectedCompany && selectedDateRange[0] && selectedDateRange[1]) {
      return translation.get(language, "Reservation timeframe selected");
    }
  }, [endTimeOk, selectedDateRange, selectedCompany, language]);

  const showTimeSelection = useMemo(() => {
    if (FEATURE_NO_TIME_SELECT) {
      return false;
    }
    if (FEATURE_FIXED_RESERVATION_DURATION) {
      return false;
    }

    return true;
  }, [FEATURE_NO_TIME_SELECT, FEATURE_FIXED_RESERVATION_DURATION]);

  const timeselectVisible = useMemo(() => {
    if (selectedCompany?.disableMultiday && isValid(selectedDateRange[0])) {
      return true;
    }
    if (isValid(selectedDateRange[1])) return true;
    return false;
  }, [selectedCompany?.disableMultiday, selectedDateRange]);

  return (
    <Dialog
      open={openDateRangeMobile}
      scroll="paper"
      PaperProps={{
        style: {
          borderRadius: "14px",
          margin: "10px",
        },
      }}
    >
      <DialogContent
        sx={{
          backgroundColor: theme.palette.primary.dialogBackground,
          padding: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton
              aria-label="close"
              onClick={() => setOpenDateRangeMobile(false)}
              sx={{ zIndex: 999 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Grid container justify="center">
            <Grid
              item
              xs={12}
              style={{
                transition: "350ms ease-in-out",
                //   backgroundColor: titleBgColor(),
                borderRadius: 7,
                color: theme.palette.primary.dateRangeTitle,

                height: 34,
              }}
            >
              <Typography
                style={{
                  padding: 5,

                  fontWeight: "normal",
                }}
                variant="h5"
                align="center"
              >
                {title}
              </Typography>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              padding: "5px",
            }}
          >
            {(FEATURE_FIXED_RESERVATION_DURATION && disableMultiday) ||
              (!disableMultiday && (
                <StaticDateRangePicker
                  minDate={getMinimumDate()}
                  displayStaticWrapperAs="desktop"
                  calendars={1}
                  disabled={!selectedCompany}
                  open={true}
                  disablePast
                  onChange={(newValue) => handleDateChange(newValue)}
                  value={selectedDateRange}
                  renderInput={(startProps, endProps) => <></>}
                />
              ))}

            {disableMultiday && !FEATURE_FIXED_RESERVATION_DURATION && (
              <StaticDatePicker
                minDate={getMinimumDate()}
                displayStaticWrapperAs={"desktop"}
                label={translation.get(language, "Date label")}
                disabled={!selectedCompany}
                open
                disableMaskedInput
                disablePast
                value={selectedDateRange[0]}
                onChange={(newValue) => {
                  handleDateChange(newValue);
                }}
                renderInput={(params) => {
                  return (
                    <Box>
                      {/*      <DatePickerDateInput
                        contentHeigth={contentHeigth}
                        id={"single-day-picker"}
                        pickerProps={customProps}
                        selectedPicker={selectedPicker}
                        setSelectedPicker={setSelectedPicker}
                      /> */}
                    </Box>
                  );
                }}
              />
            )}
          </Box>
          {showTimeSelection && timeselectVisible && (
            <Stack
              direction="row"
              spacing={1}
              sx={{
                width: "90%",
              }}
            >
              {/* <Grid
              item
              xs={12}
              sx={{
                //       backgroundColor: theme.palette.primary.dateRangeBgTo,
                borderRadius: 7,
                color: theme.palette.primary.dateRangeTitle,
                color: "black",
                marginBottom: "5px",
                height: 34,
              }}
            >
              <Typography
                style={{
                  padding: 5,

                  fontWeight: "normal",
                }}
                variant="h5"
                align="center"
              >
                {FEATURE_FIXED_RESERVATION_TIMEFRAME
                  ? `${translation.get(
                      language,
                      "Mobile datepicker solid time"
                    )}`
                  : `${translation.get(
                      language,
                      "Mobile datepicker select time"
                    )}`}
              </Typography>
            </Grid> */}

              <Stack direction="column">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    variant="body1"
                    style={{
                      color: theme.palette.primary.mainText,
                    }}
                  >
                    {translation.get(language, "Pickup time text")}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: "bolder",

                      color: theme.palette.primary.mainText,
                    }}
                  >
                    {startDateString}
                  </Typography>
                </div>
                <TimePicker
                  autoOk
                  disabled={FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA}
                  ampm={false}
                  value={startTime}
                  onChange={(time) => {
                    if (FEATURE_FIXED_RESERVATION_DURATION) {
                      setEndTime(addHours(time, selectedTimeFrame));
                      setStartTime(time);
                    } else {
                      setStartTime(time);
                    }
                  }}
                  inputVariant="outlined"
                  margin="dense"
                  cancelLabel="Peruuta"
                  disableToolbar
                  error={hasError}
                  renderInput={(params) => <TextField {...params} />}
                  toolbarTitle={startTimeLabel}
                  components={{
                    ActionBar: TimePickerActionBar,
                  }}
                />
              </Stack>
              {/*  {!FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA && (
              <Slider
                sx={{ width: "90%", marginTop: "10px" }}
                valueLabelDisplay="off"
                value={startSliderValue}
                step={1}
                max={47}
                onChange={throttle((_, v) => {
                  const minutes = v * SLIDER_STEP;
                  const time = add(dayStart, { minutes });
                  setStartTime(
                    set(selectedDateRange[0], {
                      hours: time.getHours(),
                      minutes: time.getMinutes(),
                    })
                  );
                  if (
                    FEATURE_FIXED_RESERVATION_TIMEFRAME ||
                    selectedCompany?.disableMultiday
                  ) {
                    setEndTime(addHours(startTime, selectedTimeFrame));
                  }
                }, 100)}
              />
            )} */}
              {!FEATURE_FIXED_RESERVATION_DURATION && (
                <Stack direction={"column"}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <Typography
                      variant="body1"
                      style={{
                        color: theme.palette.primary.mainText,
                      }}
                    >
                      {translation.get(language, "Return time text")}:
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{
                        fontWeight: "bolder",

                        color: theme.palette.primary.mainText,
                      }}
                    >
                      {endDateString}
                    </Typography>
                  </div>
                  <TimePicker
                    disabled={FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                    autoOk
                    ampm={false}
                    value={endTime}
                    onChange={setEndTime}
                    inputVariant="outlined"
                    margin="dense"
                    cancelLabel="Peruuta"
                    disableToolbar
                    error={hasError}
                    toolbarTitle={returnTimeLabel}
                    components={{
                      ActionBar: TimePickerActionBar,
                    }}
                  />

                  {/*   {!FEATURE_FIXED_RESERVATION_TIMEFRAME_GNISTA && (
                  <Slider
                    valueLabelDisplay="off"
                    value={endSliderValue}
                    step={1}
                    max={47}
                    onChange={throttle((_, v) => {
                      const minutes = v * SLIDER_STEP;
                      const time = add(dayStart, { minutes });
                      setEndTime(
                        set(selectedDateRange[1], {
                          hours: time.getHours(),
                          minutes: time.getMinutes(),
                        })
                      );
                    }, 100)}
                  />
                )} */}
                </Stack>
              )}
              {FEATURE_FIXED_RESERVATION_TIMEFRAME && (
                <Stack direction={"column"}>
                  <Typography variant="body1">
                    {translation.get(language, "Return time text")}
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 550 }}>
                    {isValid(endTime) &&
                      format(endTime, "eeeeee dd.MM", {
                        locale: locale,
                      })}
                  </Typography>

                  <TimePicker
                    disabled
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        sx={{
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#000000",
                          },
                        }}
                      />
                    )}
                    autoOk
                    ampm={false}
                    value={endTime}
                    inputVariant="outlined"
                    margin="dense"
                    disableToolbar
                    error={hasError}
                    toolbarTitle={returnTimeLabel}
                    components={{
                      ActionBar: TimePickerActionBar,
                    }}
                  />
                </Stack>
              )}
            </Stack>
          )}
          {FEATURE_FIXED_RESERVATION_TIMEFRAME && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                marginTop: "10px",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "16px",
                  marginBottom: "5px",
                }}
              >
                {translation.get(language, "Select duration label")}
              </Typography>
              {FEATURE_FIXED_RESERVATION_TIMEFRAME && (
                <Grid
                  container
                  direction="row"
                  justify="space-evenly"
                  style={{
                    marginBottom: 20,
                  }}
                >
                  {fixedTimeFrames.map((item, index) => {
                    return (
                      <FixedTimeFrameSelect
                        key={item + index}
                        value={item}
                        selectedTimeFrame={selectedTimeFrame}
                        indexValue={index}
                      />
                    );
                  })}
                </Grid>
              )}
            </Box>
          )}
          <Grid container alignItems="center" direction="column">
            {VUOKRAAPAKU_SPECIAL_COMPANY && (
              <Grid item>
                <Alert
                  variant="filled"
                  severity={startEndSameDay ? "info" : "success"}
                  style={{
                    transition: "350ms ease-in-out",
                  }}
                >
                  Voit halutessasi valita palautuksen seuraavalle päivälle
                </Alert>
              </Grid>
            )}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box
          sx={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            color="secondary"
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: "bolder",
              letterSpacing: 1,
              fontSize: "18px",
              fontFamily: "Sofia Pro",
              width: "33%",
              borderRadius: "45px",

              color: theme.palette.primary.buttonText,
            }}
            onClick={() => handleAdvance()}
            disabled={!dateRange.from || hasError}
          >
            Ok
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

const TimePickerActionBar = ({ onAccept, onCancel, onClear, onSetToday }) => {
  const { language } = useContext(AppContext);
  return (
    <DialogActions>
      <Button onClick={onCancel}>
        {translation.get(language, "Cancel text")}
      </Button>
      <Button onClick={onAccept}> Ok </Button>
    </DialogActions>
  );
};
